<template>
  <tg-button
    :classes="['tg-btn--search']"
    round
    icon="search"
    @click.native="clickHandler"
  >{{ label }}</tg-button>
</template>

<script>
import TgButton from "@/components/button/TgButton";

export default {
  props: {
    text: String
  },
  components: {
    TgButton
  },
  name: "ThirdPartySearchBtn",
  methods: {
    clickHandler(event) {
      this.$emit("click", event);
    }
  },
  computed: {
    label() {
      if(this.text){
        return this.text;
      }
      return this.$t('component.btn.source_type_choose');
    },
  }
};
</script>
